module.exports = __webpack_public_path__ + "16dc9819cb371f042475ae8b0c309cba.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-BlackItalic.ttf
// module id = 1241
// module chunks = 0